// extracted by mini-css-extract-plugin
export default {"rating":"dQ-z","numberOfStars":"eQ-z","count":"fQ-z","barGraphSpacing":"gQ-z","barGraph":"hQ-z"};